<template>
<div class="chapter">
<div class="inner_page">
<h1 class="epub_toctitle">Contents</h1>
<ul class="epub_toc">
<li class="epub_tocitem" id="N157755">
<a href="#/N157755">Title Page</a>
</li>
<li class="epub_tocitem" id="N157756">
<a href="#/N157756">Copyright Page</a>
</li>
<li class="epub_tocitem" id="N157757">
<a href="#/N157757">Introduction</a>
</li>
<li class="epub_tocitem" id="N157758">
<a href="#/N157758">Part 1: The Basics of Tarot</a>
<ul>
<li class="epub_tocitem" id="N157759">
<a href="#/N157759">Chapter 1: An Introduction to Tarot</a>
<ul>
<li class="epub_tocitem" id="N157759_A-157759_41">
<a href="#/N157759#A-157759_41">History of the Tarot</a>
</li>
<li class="epub_tocitem" id="N157759_A-157759_59">
<a href="#/N157759#A-157759_59">Early Tarot Decks</a>
</li>
<li class="epub_tocitem" id="N157759_A-157759_115">
<a href="#/N157759#A-157759_115">Choosing a Tarot Deck</a>
</li>
<li class="epub_tocitem" id="N157759_A-157759_149">
<a href="#/N157759#A-157759_149">Handling Your Deck</a>
</li>
<li class="epub_tocitem" id="N157759_A-157759_201">
<a href="#/N157759#A-157759_201">Storing Your Cards</a>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157760">
<span href="#/N157760" title="Link target outside of Sample">Chapter 2: Learning to Interpret the Tarot</span>
<ul>
<li class="epub_tocitem" id="N157760_A-157760_41">
<span href="#/N157760#A-157760_41" title="Link target outside of Sample">Exploring the Tarot</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_77">
<span href="#/N157760#A-157760_77" title="Link target outside of Sample">The Four Suits</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_111">
<span href="#/N157760#A-157760_111" title="Link target outside of Sample">Teach Yourself Tarot</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_147">
<span href="#/N157760#A-157760_147" title="Link target outside of Sample">Use Your Intuition</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_173">
<span href="#/N157760#A-157760_173" title="Link target outside of Sample">Where to Begin</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_191">
<span href="#/N157760#A-157760_191" title="Link target outside of Sample">The Tarot as a Tool for Divination</span>
</li>
<li class="epub_tocitem" id="N157760_A-157760_209">
<span href="#/N157760#A-157760_209" title="Link target outside of Sample">Keep a Tarot Journal</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157761">
<span href="#/N157761" title="Link target outside of Sample">Chapter 3: Symbolism in the Tarot Deck</span>
<ul>
<li class="epub_tocitem" id="N157761_A-157761_41">
<span href="#/N157761#A-157761_41" title="Link target outside of Sample">Symbols in the Suits</span>
</li>
<li class="epub_tocitem" id="N157761_A-157761_99">
<span href="#/N157761#A-157761_99" title="Link target outside of Sample">The Power of Numbers</span>
</li>
<li class="epub_tocitem" id="N157761_A-157761_221">
<span href="#/N157761#A-157761_221" title="Link target outside of Sample">The Meaning of Color</span>
</li>
<li class="epub_tocitem" id="N157761_A-157761_239">
<span href="#/N157761#A-157761_239" title="Link target outside of Sample">Familiar Symbols</span>
</li>
</ul>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157762">
<span href="#/N157762" title="Link target outside of Sample">Part 2: The Major and Minor Arcana</span>
<ul>
<li class="epub_tocitem" id="N157763">
<span href="#/N157763" title="Link target outside of Sample">Chapter 4: Description and Meanings of the Major Arcana</span>
<ul>
<li class="epub_tocitem" id="N157763_A-157763_41">
<span href="#/N157763#A-157763_41" title="Link target outside of Sample">An Introduction to the Trumps</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_69">
<span href="#/N157763#A-157763_69" title="Link target outside of Sample">The Fool</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_111">
<span href="#/N157763#A-157763_111" title="Link target outside of Sample">The Magician</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_161">
<span href="#/N157763#A-157763_161" title="Link target outside of Sample">The High Priestess</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_205">
<span href="#/N157763#A-157763_205" title="Link target outside of Sample">The Empress</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_247">
<span href="#/N157763#A-157763_247" title="Link target outside of Sample">The Emperor</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_293">
<span href="#/N157763#A-157763_293" title="Link target outside of Sample">The Hierophant</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_341">
<span href="#/N157763#A-157763_341" title="Link target outside of Sample">The Lovers</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_381">
<span href="#/N157763#A-157763_381" title="Link target outside of Sample">The Chariot</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_425">
<span href="#/N157763#A-157763_425" title="Link target outside of Sample">Strength</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_473">
<span href="#/N157763#A-157763_473" title="Link target outside of Sample">The Hermit</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_515">
<span href="#/N157763#A-157763_515" title="Link target outside of Sample">The Wheel of Fortune</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_557">
<span href="#/N157763#A-157763_557" title="Link target outside of Sample">Justice</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_597">
<span href="#/N157763#A-157763_597" title="Link target outside of Sample">The Hanged Man</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_639">
<span href="#/N157763#A-157763_639" title="Link target outside of Sample">Death</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_679">
<span href="#/N157763#A-157763_679" title="Link target outside of Sample">Temperance</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_717">
<span href="#/N157763#A-157763_717" title="Link target outside of Sample">The Devil</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_763">
<span href="#/N157763#A-157763_763" title="Link target outside of Sample">The Tower</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_807">
<span href="#/N157763#A-157763_807" title="Link target outside of Sample">The Star</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_847">
<span href="#/N157763#A-157763_847" title="Link target outside of Sample">The Moon</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_897">
<span href="#/N157763#A-157763_897" title="Link target outside of Sample">The Sun</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_939">
<span href="#/N157763#A-157763_939" title="Link target outside of Sample">Judgment</span>
</li>
<li class="epub_tocitem" id="N157763_A-157763_977">
<span href="#/N157763#A-157763_977" title="Link target outside of Sample">The World</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157764">
<span href="#/N157764" title="Link target outside of Sample">Chapter 5: The Suit of Wands</span>
<ul>
<li class="epub_tocitem" id="N157764_A-157764_41">
<span href="#/N157764#A-157764_41" title="Link target outside of Sample">Interpreting the Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_51">
<span href="#/N157764#A-157764_51" title="Link target outside of Sample">King of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_75">
<span href="#/N157764#A-157764_75" title="Link target outside of Sample">Queen of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_99">
<span href="#/N157764#A-157764_99" title="Link target outside of Sample">Knight of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_123">
<span href="#/N157764#A-157764_123" title="Link target outside of Sample">Page of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_147">
<span href="#/N157764#A-157764_147" title="Link target outside of Sample">Ace of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_171">
<span href="#/N157764#A-157764_171" title="Link target outside of Sample">Two of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_195">
<span href="#/N157764#A-157764_195" title="Link target outside of Sample">Three of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_219">
<span href="#/N157764#A-157764_219" title="Link target outside of Sample">Four of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_243">
<span href="#/N157764#A-157764_243" title="Link target outside of Sample">Five of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_267">
<span href="#/N157764#A-157764_267" title="Link target outside of Sample">Six of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_291">
<span href="#/N157764#A-157764_291" title="Link target outside of Sample">Seven of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_315">
<span href="#/N157764#A-157764_315" title="Link target outside of Sample">Eight of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_339">
<span href="#/N157764#A-157764_339" title="Link target outside of Sample">Nine of Wands</span>
</li>
<li class="epub_tocitem" id="N157764_A-157764_363">
<span href="#/N157764#A-157764_363" title="Link target outside of Sample">Ten of Wands</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157765">
<span href="#/N157765" title="Link target outside of Sample">Chapter 6: The Suit of Pentacles</span>
<ul>
<li class="epub_tocitem" id="N157765_A-157765_41">
<span href="#/N157765#A-157765_41" title="Link target outside of Sample">Interpreting the Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_53">
<span href="#/N157765#A-157765_53" title="Link target outside of Sample">King of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_79">
<span href="#/N157765#A-157765_79" title="Link target outside of Sample">Queen of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_103">
<span href="#/N157765#A-157765_103" title="Link target outside of Sample">Knight of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_127">
<span href="#/N157765#A-157765_127" title="Link target outside of Sample">Page of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_151">
<span href="#/N157765#A-157765_151" title="Link target outside of Sample">Ace of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_175">
<span href="#/N157765#A-157765_175" title="Link target outside of Sample">Two of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_199">
<span href="#/N157765#A-157765_199" title="Link target outside of Sample">Three of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_223">
<span href="#/N157765#A-157765_223" title="Link target outside of Sample">Four of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_247">
<span href="#/N157765#A-157765_247" title="Link target outside of Sample">Five of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_271">
<span href="#/N157765#A-157765_271" title="Link target outside of Sample">Six of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_295">
<span href="#/N157765#A-157765_295" title="Link target outside of Sample">Seven of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_319">
<span href="#/N157765#A-157765_319" title="Link target outside of Sample">Eight of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_343">
<span href="#/N157765#A-157765_343" title="Link target outside of Sample">Nine of Pentacles</span>
</li>
<li class="epub_tocitem" id="N157765_A-157765_367">
<span href="#/N157765#A-157765_367" title="Link target outside of Sample">Ten of Pentacles</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157766">
<span href="#/N157766" title="Link target outside of Sample">Chapter 7: The Suit of Swords</span>
<ul>
<li class="epub_tocitem" id="N157766_A-157766_41">
<span href="#/N157766#A-157766_41" title="Link target outside of Sample">Interpreting the Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_57">
<span href="#/N157766#A-157766_57" title="Link target outside of Sample">King of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_81">
<span href="#/N157766#A-157766_81" title="Link target outside of Sample">Queen of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_105">
<span href="#/N157766#A-157766_105" title="Link target outside of Sample">Knight of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_129">
<span href="#/N157766#A-157766_129" title="Link target outside of Sample">Page of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_153">
<span href="#/N157766#A-157766_153" title="Link target outside of Sample">Ace of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_177">
<span href="#/N157766#A-157766_177" title="Link target outside of Sample">Two of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_201">
<span href="#/N157766#A-157766_201" title="Link target outside of Sample">Three of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_225">
<span href="#/N157766#A-157766_225" title="Link target outside of Sample">Four of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_249">
<span href="#/N157766#A-157766_249" title="Link target outside of Sample">Five of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_273">
<span href="#/N157766#A-157766_273" title="Link target outside of Sample">Six of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_297">
<span href="#/N157766#A-157766_297" title="Link target outside of Sample">Seven of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_321">
<span href="#/N157766#A-157766_321" title="Link target outside of Sample">Eight of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_345">
<span href="#/N157766#A-157766_345" title="Link target outside of Sample">Nine of Swords</span>
</li>
<li class="epub_tocitem" id="N157766_A-157766_369">
<span href="#/N157766#A-157766_369" title="Link target outside of Sample">Ten of Swords</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157767">
<span href="#/N157767" title="Link target outside of Sample">Chapter 8: The Suit of Cups</span>
<ul>
<li class="epub_tocitem" id="N157767_A-157767_41">
<span href="#/N157767#A-157767_41" title="Link target outside of Sample">Interpreting the Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_49">
<span href="#/N157767#A-157767_49" title="Link target outside of Sample">King of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_73">
<span href="#/N157767#A-157767_73" title="Link target outside of Sample">Queen of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_97">
<span href="#/N157767#A-157767_97" title="Link target outside of Sample">Knight of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_121">
<span href="#/N157767#A-157767_121" title="Link target outside of Sample">Page of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_145">
<span href="#/N157767#A-157767_145" title="Link target outside of Sample">Ace of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_169">
<span href="#/N157767#A-157767_169" title="Link target outside of Sample">Two of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_193">
<span href="#/N157767#A-157767_193" title="Link target outside of Sample">Three of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_217">
<span href="#/N157767#A-157767_217" title="Link target outside of Sample">Four of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_241">
<span href="#/N157767#A-157767_241" title="Link target outside of Sample">Five of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_265">
<span href="#/N157767#A-157767_265" title="Link target outside of Sample">Six of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_289">
<span href="#/N157767#A-157767_289" title="Link target outside of Sample">Seven of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_313">
<span href="#/N157767#A-157767_313" title="Link target outside of Sample">Eight of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_337">
<span href="#/N157767#A-157767_337" title="Link target outside of Sample">Nine of Cups</span>
</li>
<li class="epub_tocitem" id="N157767_A-157767_361">
<span href="#/N157767#A-157767_361" title="Link target outside of Sample">Ten of Cups</span>
</li>
</ul>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157768">
<span href="#/N157768" title="Link target outside of Sample">Part 3: Performing Tarot Readings</span>
<ul>
<li class="epub_tocitem" id="N157769">
<span href="#/N157769" title="Link target outside of Sample">Chapter 9: How to Do Readings</span>
<ul>
<li class="epub_tocitem" id="N157769_A-157769_41">
<span href="#/N157769#A-157769_41" title="Link target outside of Sample">Focus and Attitude Are Key</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_63">
<span href="#/N157769#A-157769_63" title="Link target outside of Sample">Ask Clear Questions</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_85">
<span href="#/N157769#A-157769_85" title="Link target outside of Sample">Understand That the Future Is Not Fixed</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_103">
<span href="#/N157769#A-157769_103" title="Link target outside of Sample">Reading for Yourself</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_223">
<span href="#/N157769#A-157769_223" title="Link target outside of Sample">Reading for Others</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_261">
<span href="#/N157769#A-157769_261" title="Link target outside of Sample">Practice Different Spreads</span>
</li>
<li class="epub_tocitem" id="N157769_A-157769_277">
<span href="#/N157769#A-157769_277" title="Link target outside of Sample">How Often Should You Do Readings?</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157770">
<span href="#/N157770" title="Link target outside of Sample">Chapter 10: Tarot Spreads</span>
<ul>
<li class="epub_tocitem" id="N157770_A-157770_41">
<span href="#/N157770#A-157770_41" title="Link target outside of Sample">Acquainting Yourself with Spreads</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_69">
<span href="#/N157770#A-157770_69" title="Link target outside of Sample">Choosing a Significator</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_213">
<span href="#/N157770#A-157770_213" title="Link target outside of Sample">Lay Out the Spread</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_235">
<span href="#/N157770#A-157770_235" title="Link target outside of Sample">Interpret the Spread</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_261">
<span href="#/N157770#A-157770_261" title="Link target outside of Sample">Which Spread Should You Use?</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_279">
<span href="#/N157770#A-157770_279" title="Link target outside of Sample">The Significance of Trumps in a Spread</span>
</li>
<li class="epub_tocitem" id="N157770_A-157770_305">
<span href="#/N157770#A-157770_305" title="Link target outside of Sample">Creating Your Own Spreads</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157771">
<span href="#/N157771" title="Link target outside of Sample">Chapter 11: Sixteen Spreads</span>
<ul>
<li class="epub_tocitem" id="N157771_A-157771_41">
<span href="#/N157771#A-157771_41" title="Link target outside of Sample">Single-Card Method</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_57">
<span href="#/N157771#A-157771_57" title="Link target outside of Sample">Yes/No Method</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_133">
<span href="#/N157771#A-157771_133" title="Link target outside of Sample">Either/Or Method</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_147">
<span href="#/N157771#A-157771_147" title="Link target outside of Sample">Past-Present-Future Method</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_161">
<span href="#/N157771#A-157771_161" title="Link target outside of Sample">Immediate Situation Three-Card Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_209">
<span href="#/N157771#A-157771_209" title="Link target outside of Sample">Four-Card Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_267">
<span href="#/N157771#A-157771_267" title="Link target outside of Sample">Practical Advice Five-Card Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_335">
<span href="#/N157771#A-157771_335" title="Link target outside of Sample">Traditional Celtic Cross Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_453">
<span href="#/N157771#A-157771_453" title="Link target outside of Sample">General Life Conditions Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_531">
<span href="#/N157771#A-157771_531" title="Link target outside of Sample">Quick Answer Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_619">
<span href="#/N157771#A-157771_619" title="Link target outside of Sample">The Horseshoe Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_707">
<span href="#/N157771#A-157771_707" title="Link target outside of Sample">The World Tree Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_755">
<span href="#/N157771#A-157771_755" title="Link target outside of Sample">The Tree of Life Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_873">
<span href="#/N157771#A-157771_873" title="Link target outside of Sample">Feng Shui Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_981">
<span href="#/N157771#A-157771_981" title="Link target outside of Sample">Horoscope Spread</span>
</li>
<li class="epub_tocitem" id="N157771_A-157771_1149">
<span href="#/N157771#A-157771_1149" title="Link target outside of Sample">Thirteen-Card Story Spread</span>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157772">
<span href="#/N157772" title="Link target outside of Sample">Chapter 12: Using the Tarot for Personal Development and Growth</span>
<ul>
<li class="epub_tocitem" id="N157772_A-157772_41">
<span href="#/N157772#A-157772_41" title="Link target outside of Sample">Daily Insights from the Tarot</span>
</li>
<li class="epub_tocitem" id="N157772_A-157772_59">
<span href="#/N157772#A-157772_59" title="Link target outside of Sample">Daily Affirmations and the Tarot</span>
</li>
<li class="epub_tocitem" id="N157772_A-157772_75">
<span href="#/N157772#A-157772_75" title="Link target outside of Sample">Reflecting on the Major Arcana for Inner Truths</span>
</li>
<li class="epub_tocitem" id="N157772_A-157772_97">
<span href="#/N157772#A-157772_97" title="Link target outside of Sample">Working with the Minor Arcana for Specific Issues</span>
</li>
<li class="epub_tocitem" id="N157772_A-157772_127">
<span href="#/N157772#A-157772_127" title="Link target outside of Sample">Connect with Your Intuition</span>
</li>
</ul>
</li>
</ul>
</li>
<li class="epub_tocitem" id="N157773">
<span href="#/N157773" title="Link target outside of Sample">Appendix: Glossary of Terms</span>
</li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?932aaa3a